import { Alert, Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import BackButton from '@/components/ui/BackButton/BackButton.tsx';
import LoaderWrapper from '@/components/ui/LoaderWrapper/LoaderWrapper.tsx';
import useOrders from '@/api/useOrders.ts';
import Message from '@/components/ui/Message/Message.tsx';

type OrderModalProps = {
  isOpen: boolean;
  onClose: () => void;
  reservationId: number;
};

function OrderModal({ isOpen, onClose, reservationId }: OrderModalProps) {
  const { t } = useTranslation();

  const {
    data: orders,
    isLoading: isLoadingOrders,
    isError: isErrorLoadingOrders,
    error: errorOrders,
  } = useOrders(!!reservationId, {
    reservation_id: reservationId,
  });

  const hasOrders = !!orders && orders.length > 0;

  return (
    <Dialog open={isOpen} onClose={onClose} maxWidth="md">
      <DialogTitle>{t('modals.orderModal.title')}</DialogTitle>
      <DialogContent>
        <div className="flex flex-col gap-4">
          <div className="flex flex-col gap-2 empty:hidden mb-2">
            {isErrorLoadingOrders && <Alert severity="error">{errorOrders.message}</Alert>}
          </div>
          <LoaderWrapper isLoading={isLoadingOrders} className="flex flex-col gap-4 w-[552px] max-w-full">
            <div className="flex flex-col gap-2 w-[552px] max-w-full">
              {hasOrders ? (
                orders?.map((order) => <Message key={`order_${order.id}`} message={order.order} />)
              ) : (
                <Alert severity="info">{t('modals.orderModal.noOrder')}</Alert>
              )}
            </div>
          </LoaderWrapper>
        </div>
      </DialogContent>
      <DialogActions>
        <div className="flex grow p-4 pt-0 justify-start">
          <BackButton onClick={onClose} autoFocus />
        </div>
      </DialogActions>
    </Dialog>
  );
}

export default OrderModal;
